export class Rest
{
	applyFilter(parent)
	{
		let el = $(parent);
		if (el.prop('checked'))
		{
			if (el.val() == '' || el.attr('type') == 'radio')
			{
				this.removeAllChoiced(el.attr('name').replace('[]', ''));
			}
			
			if (el.val() != '')
			{
				this.addChoiced(el.attr('name').replace('[]', ''), el.val(), el.closest('.form__check').find('.form__check-caption').text());
			}
		}
		else
		{
			this.removeChoiced(el.attr('name').replace('[]', ''), el.val());
		}

		this.loadItems(parent.form);
	}

	loadItems(parent = null)
	{
		let _this = this;
		let data;

		data = $(parent).serialize();
		data += '&action=loadItems';

		$.ajax({
			url: "/ajax.php?mid=22",
			type: 'POST',
			data: data,
			dataType: "html",
			success: function(html){
				let table = $('.restaurants__table').replaceWith(html);
			},
			error: function(err){
				if (err.statusText === "abort") {
            // Запрос был прерван, можно просто проигнорировать
            console.warn('Запрос был прерван.');
        } else {
            // Обработка остальных ошибок
            alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
        }
			}
		});
	}

	addChoiced(name, value, text)
	{
		let ul = $('.filters-choiced__list');
		ul.append('<li class="filters-choiced__item"><button class="btn btn--s filters-choiced__item-btn" type="button" data-filter="' + name + '" value="' + value + '" onclick="tour.deleteChoiced(this);"><span>' + text + '</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M17.7208 6.27916C17.542 6.10042 17.2996 6 17.0467 6C16.7939 6 16.5514 6.10042 16.3726 6.27916L12 10.6518L7.62737 6.27916C7.44857 6.10042 7.2061 6 6.95327 6C6.70044 6 6.45797 6.10042 6.27916 6.27916C6.10042 6.45797 6 6.70044 6 6.95327C6 7.2061 6.10042 7.44857 6.27916 7.62737L10.6518 12L6.27916 16.3726C6.10042 16.5514 6 16.7939 6 17.0467C6 17.2996 6.10042 17.542 6.27916 17.7208C6.45797 17.8996 6.70044 18 6.95327 18C7.2061 18 7.44857 17.8996 7.62737 17.7208L12 13.3482L16.3726 17.7208C16.5514 17.8996 16.7939 18 17.0467 18C17.2996 18 17.542 17.8996 17.7208 17.7208C17.8996 17.542 18 17.2996 18 17.0467C18 16.7939 17.8996 16.5514 17.7208 16.3726L13.3482 12L17.7208 7.62737C17.8996 7.44857 18 7.2061 18 6.95327C18 6.70044 17.8996 6.45797 17.7208 6.27916V6.27916Z" fill="#374957"></path></svg></button></li>');
	}

	removeChoiced(name, value)
	{
		console.log(name);
		console.log(value);
		$('.filters-choiced__list li.filters-choiced__item button[data-filter="' + name + '"][value="' + value + '"]').closest('li').remove();
	}

	removeAllChoiced(name)
	{
		console.log(name);
		$('.filters-choiced__list li.filters-choiced__item button[data-filter="' + name + '"]').closest('li').remove();
	}

	deleteChoiced(parent)
	{
		let el = $(parent);
		let name = el.attr('data-filter');
		let value = el.val();
		$('.filters__choice-list[data-filter="' + name + '"] input[value="' + value + '"]').prop('checked', 0).trigger('change');
	}
}